module.exports = __webpack_public_path__ + "static/colors-themes-video-do-69f6e939f57c73dae4ee057f53a95aa3.png";